/**
 * mothers-day-bundles.js
 * Handles Add-to-Cart for Mother's Day bundle cards.
 * - Adds all bundle products via /cart/add.js
 * - Reloads the page and triggers the cart icon click to open the drawer
 *   (using the same mechanism the user would use, compatible with any cart app)
 */

(function () {
  'use strict';

  /* ── Auto-open drawer on page load if flagged ── */
  var shouldOpenDrawer = sessionStorage.getItem('md-open-drawer');
  if (shouldOpenDrawer) {
    sessionStorage.removeItem('md-open-drawer');

    // Wait for the page (and any third-party apps) to fully load
    function triggerCartOpen() {
      // Programmatically click the header cart icon — this triggers
      // whatever handler (theme or app) normally opens the cart drawer
      var cartLink = document.querySelector('.header__cart');
      if (cartLink) {
        cartLink.click();
      }
    }

    if (document.readyState === 'complete') {
      // Delay slightly to let third-party app scripts initialize
      setTimeout(triggerCartOpen, 800);
    } else {
      window.addEventListener('load', function () {
        setTimeout(triggerCartOpen, 800);
      });
    }
  }

  /* ── Add-to-Cart click handler ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-add]');
    if (!btn) return;

    // Skip if this is a quiz ATC button (handled by gift-quiz.liquid)
    if (btn.classList.contains('gq-atc-btn')) return;

    var productsRaw = btn.getAttribute('data-bundle-products');
    var products;
    try {
      products = JSON.parse(productsRaw);
    } catch (err) {
      console.error('[MD Bundles] Could not parse bundle products:', err, productsRaw);
      return;
    }

    // Filter out any items with falsy id
    products = products.filter(function (p) { return p && p.id; });
    if (!products.length) {
      console.warn('[MD Bundles] No valid products to add.');
      return;
    }

    // Disable button while adding
    btn.disabled = true;
    btn.textContent = 'Adding...';
    btn.classList.add('md-bundle-card__cta--loading');

    // Build payload
    var payload = {
      items: products.map(function (p) {
        return { id: p.id, quantity: p.quantity || 1 };
      })
    };

    // Use an iframe to obtain a pristine, un-intercepted browser fetch function.
    // This guarantees 100% reliable Add-to-Cart execution on the first click,
    // bypassing any third-party app (like Planet) fetch overrides or race conditions.
    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var pristineFetch = iframe.contentWindow ? iframe.contentWindow.fetch : window.fetch;

    pristineFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) {
          return res.text().then(function (body) {
            throw new Error('Cart add failed: ' + res.status + ' — ' + body);
          });
        }
        return res.json();
      })
      .then(function () {
        btn.textContent = 'Added ✓';
        btn.classList.remove('md-bundle-card__cta--loading');
        btn.classList.add('md-bundle-card__cta--success');

        // Flag the drawer to open on reload, then reload
        sessionStorage.setItem('md-open-drawer', '1');
        // Small delay so user sees "Added ✓" before reload
        setTimeout(function () {
          window.location.reload();
        }, 400);
      })
      .catch(function (err) {
        console.error('[MD Bundles] Add to cart error:', err);
        btn.textContent = 'Error — try again';
        btn.classList.remove('md-bundle-card__cta--loading');
        btn.style.color = '#c0392b';
        setTimeout(function () {
          btn.textContent = 'ADD TO CART';
          btn.style.color = '';
          btn.disabled = false;
        }, 3000);
      })
      .finally(function () {
        if (iframe && iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
      });
  });

  /* ── Scroll-reveal for bundle cards ── */
  if ('IntersectionObserver' in window) {
    var revealEls = document.querySelectorAll('.reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealEls.forEach(function (el) { io.observe(el); });
  }
})();
